// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@flip/XDL/Icons/Close";
import NotificationsError from "@flip/XDL/Icons/NotificationsError";
import NotificationsInfo from "@flip/XDL/Icons/NotificationsInfo";
import NotificationsSuccess from "@flip/XDL/Icons/NotificationsSuccess";
import NotificationsWarning from "@flip/XDL/Icons/NotificationsWarning";
import { buttonTransparent } from "@flip/XDL/PreStyle/button";
import { xBaseTheme } from "@flip/XDL/types";
import { color, xScreen } from "@flip/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import ToastPropsDefault, { toasterProps as toasterPropsDefault } from "@insite/mobius/Toast/presentationProps";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css, ThemeProps } from "styled-components";

export default {
    defaultProps: {
        ...ToastPropsDefault,
        closeButtonProps: {
            mergeCss: true,
            color: "transparent",
            buttonType: "solid",
            shape: "pill",
            css: css`
                position: absolute;
                top: 8px;
                right: 5px;
                border: 0;
                width: 24px;
                height: 24px;
                padding: 0;
                ${buttonTransparent}
                ${IconWrapper} {
                    color: ${color("text.main")};
                    &:hover {
                        color: ${color("text.main", 0.33)}!important;
                    }
                }
                &:hover:not(:disabled) {
                    ${IconWrapper} {
                        color: ${color("text.main", 0.33)}!important;
                    }
                }
            `,
            size: 24,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 10,
            color: "text.main",
            css: css`
                position: absolute;
                top: 10px;
                right: 10px;
                &:hover {
                    color: ${color("text.main", 0.33)} !important;
                }
            `,
        },
        iconProps: {
            mergeCss: true,
            size: 20,
            css: css`
                margin-top: 2px;
                margin-right: 12px;
            `,
        },
        iconSrcByMessage: {
            success: NotificationsSuccess,
            warning: NotificationsWarning,
            danger: NotificationsError,
            info: NotificationsInfo,
        },
        bodyTypographyProps: {
            mergeCss: true,
            css: css`
                line-height: 22px;
                ${({ theme }: ThemeProps<BaseTheme>) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                font-size: 12px;
                            `,
                            null,
                            css`
                                font-size: 14px;
                            `,
                            null,
                            null,
                        ],
                        "min",
                    )}
            `,
            color: "text.main",
        },
        cssOverrides: {
            toast: css`
                border-style: solid;
                border-width: 1px;
                border-radius: 2px;
                background: ${({ messageType }: any) => color(`${messageType}.light`)};
                @media print {
                    display: none;
                }
                ${xScreen("lte", "xs")} {
                    max-width: calc(100% - 30px);
                    margin: 0 15px;
                }
            `,
            toastBody: css`
                &&& {
                    margin: 0;
                }
                align-items: flex-start;
                padding: 12px 30px 12px 12px;
            `,
        },
    },
    toasterProps: {
        ...toasterPropsDefault,
    },
} as xBaseTheme["toast"];
